import { Fragment, useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { signal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import BoardCards from "componentsv2/card/BoardCards";
import { cn } from "tools/ui";
import { BUTTON_COLORS } from "components/Constants/constants";
import { useWizard } from "storev2/wizardStore";

const currentRecordId = signal(null);

const styleBase =
  "flex space-x-3 justify-center items-center my-auto p-2 h-12 text-center border-[1px] rounded-xl shadow-md active:scale-95 active:shadow-lg";

const open = signal(false);

function ModalCards(props) {
  const {
    layout,
    data,
    label,
    icon,
    color,
    Card,
    resetData,
    parentRec,
    buttons,
    onReset,
    field,
    // args,
    // style,
  } = props;
  const [msg, setMsg] = useState(null);
  const { reset } = useWizard();
  const _color = color ?? "blue";
  let _style = "w-full";
  const [bgColor, txtColor, border] = BUTTON_COLORS[_color];

  function onCloseMsg() {
    setMsg(null);
  }

  async function onClose(update, error) {
    if (error) {
      setMsg(error);
      reset();
      return;
    }

    open.value = false;
    reset();
    if (resetData) {
      for (const field of Object.values(resetData)) {
        field.value = null;
      }
    }
    if (onReset) {
      onReset();
    }
  }

  function openModal() {
    if (layout?.defaults) {
      // This method set default values for the wizard
      layout.defaults();
    }
    open.value = true;
  }

  let mxLabel = "mx-auto";
  if (icon) {
    mxLabel = "";
  }

  return (
    <Fragment>
      <button
        onClick={openModal}
        className={cn(styleBase, bgColor, txtColor, border, _style)}
      >
        <span className={cn("w-fit my-auto", mxLabel)}>
          <FM id={label} />
        </span>
        {icon && icon}
      </button>
      <Dialog
        title={label}
        openModal={open}
        handleClose={onClose}
        buttons={buttons}
        titleSize="text-2xl"
        size="h-full w-1/2"
      >
        <BoardCards
          parentRec={parentRec}
          records={Array.from(data.value.values())}
          layout={field.layout}
          Card={Card}
          currentRecordId={currentRecordId}
        />
      </Dialog>
    </Fragment>
  );
}

export default ModalCards;
